class IntegrationsGetter {

  constructor(access_token) {
    this.access_token = access_token
  }

  async list() {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/configurations/`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + this.access_token
        }
      }
    );
    const json_data = await response.json();
    return json_data.items;
  }
}

export default IntegrationsGetter;
